"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationMediaLinkFeaturedGrid = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const NavigationMediaLink_1 = require("./NavigationMediaLink");
const NavigationMediaLinkFeaturedGrid = (props) => {
    const { links } = props;
    return ((0, jsx_runtime_1.jsx)("div", { className: "grid grid-cols-1 grid-rows-1 gap-8 text-sm md:grid-cols-2 md:grid-rows-1", children: links.map((link, index) => ((0, jsx_runtime_1.jsx)(NavigationMediaLink_1.NavigationMediaLink, { link: link, className: "first:col-span-2 first:aspect-w-2" }, `${link.name}_${index}`))) }));
};
exports.NavigationMediaLinkFeaturedGrid = NavigationMediaLinkFeaturedGrid;
